import { IconButton, createStyles, makeStyles } from '@material-ui/core'
import { DynamicFeed } from '@material-ui/icons'
import React, { useState } from 'react'
import { GET_LIST, useQuery } from 'react-admin'
import { DynamicPropertyDialog } from './DynamicPropertyDialog'
import { ResourceName } from '../../core/ResourceName'
import Button from '../common/customized-mui-components/Button'
import { DefinitionOwnerTypes } from '../../core/enum/DefinitionOwnerTypes'
import { useHasAuthority } from '../hooks/useHasAuthority'
import { Authority } from '../../core/auth/Authority'

const useStyles = makeStyles(() =>
  createStyles({
    button: {
      margin: '2px',
    },
  }),
)

const getOwnerType = (resource: ResourceName) => {
  switch (resource) {
    case ResourceName.BOOKINGS:
      return DefinitionOwnerTypes.BOOKING
    case ResourceName.TICKETS:
      return DefinitionOwnerTypes.TICKET
    default:
      return undefined
  }
}

export const DynamicPropertyButton = ({
  record,
  refetch,
  resource,
  useSmallButton,
}: {
  record: any
  refetch: () => void
  resource: ResourceName
  useSmallButton?: boolean
}) => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false)
  const classes = useStyles()
  const hasAuthority = useHasAuthority()

  const ownerType = getOwnerType(resource)

  const { data: dynamicProperties } = useQuery(
    {
      type: GET_LIST,
      resource: ResourceName.DYNAMIC_PROPERTY_DEFINITIONS,
      payload: {
        filter: {
          definitionOwnerType: ownerType,
        },
        sort: {
          field: 'id',
          order: 'ASC',
        },
        pagination: {
          page: 1,
          perPage: 1000,
        },
      },
    },
    {
      enabled:
        !!ownerType &&
        hasAuthority(Authority.VIEW_DYNAMIC_PROPERTY_DEFINITIONS),
    },
  )

  const handleCloseDialog = () => {
    setDialogOpen(false)
  }

  const handleOpenDialog = () => {
    setDialogOpen(true)
  }

  return (
    <>
      <DynamicPropertyDialog
        close={handleCloseDialog}
        dynamicProperties={dynamicProperties}
        open={dialogOpen}
        record={record}
        refetch={refetch}
        resource={resource}
      />
      {!useSmallButton ? (
        <Button
          className={classes.button}
          variant="contained"
          onClick={handleOpenDialog}
          label={`resources.${resource}.actions.show-dynamic-properties`}
          useSmallVersionBreakpoint={false}
          disabled={!hasAuthority(Authority.VIEW_DYNAMIC_PROPERTY_DEFINITIONS)}
        />
      ) : (
        <IconButton onClick={handleOpenDialog}>
          <DynamicFeed />
        </IconButton>
      )}
    </>
  )
}
